import { autoinject, bindable } from "aurelia-framework";

@autoinject
export class UpdateSalaryInformation
{
	@bindable
  public updating: boolean;
}
